import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import {
    BigSpinner,
    ResultContainer,
    ResultLink,
    ResultsHeader,
    SearchResults,
    TypeList,
    TypeItem,
} from './styledComponents';

const SearchResult = ({
    handleOnchangeType,
    handleSearchResultClick,
    isMobile,
    isShow,
    isLoading,
    searchResult = {},
    searchTypes = [],
    selectedType = '',
    styles,
    source,
}) => {
    const {
        releases = [],
        actorsCategories = [],
        scenesCategories = [],
    } = searchResult;

    const styleObj = {
        borderColor: get(styles, 'rootStyles.borderColor', 'yellow'),
        color: get(styles, 'rootStyles.color', 'white'),
        backgroundColor: get(styles, 'rootStyles.backgroundColor', 'black'),
        activeBorderColor: get(styles, 'childrenStyles.colorIsActive.borderColor', 'yellow'),
        activeColor: get(styles, 'childrenStyles.colorIsActive.color', 'black'),
        activeBackgroundColor: get(styles, 'childrenStyles.colorIsActive.backgroundColor', 'yellow'),
        borderWidth: get(styles, 'rootStyles.borderWidth', '1px'),
    };

    return isShow && (
        <SearchResults isMobile={isMobile}>
            {searchTypes.length > 1 && (
                <TypeList>
                    {searchTypes.map(item => (
                        <TypeItem
                            isActive={selectedType === item}
                            onClick={handleOnchangeType(item)}
                            styles={styleObj}
                        >
                            {String(item).toUpperCase()}
                        </TypeItem>
                    ))}
                </TypeList>
            )}
            {isLoading && <BigSpinner color="yellow" />}
            {releases.length > 0 && (
                <div>
                    <ResultsHeader>Scenes:</ResultsHeader>
                    {releases.map(release => (
                        <ResultContainer key={release.id}>
                            <ResultLink
                                title={release.title}
                                onClick={handleSearchResultClick}
                                to={{
                                    type: 'SEARCH_VIDEOS',
                                    query: {
                                        q: release.title,
                                        source,
                                    },
                                }}
                            >
                                {release.title}
                            </ResultLink>
                        </ResultContainer>
                    ))}
                </div>
            )}
            {actorsCategories.length > 0 && (
                <div>
                    <ResultsHeader>Actors:</ResultsHeader>
                    {actorsCategories.map(categorie => (
                        <ResultContainer key={categorie.id}>
                            <ResultLink
                                title={categorie.name}
                                onClick={handleSearchResultClick}
                                to={{
                                    type: 'SEARCH_MODELS',
                                    query: {
                                        q: categorie.name,
                                        source,
                                    },
                                }}
                            >
                                {categorie.name}
                            </ResultLink>
                        </ResultContainer>
                    ))}
                </div>
            )}
            {scenesCategories.length > 0 && (
                <div>
                    <ResultsHeader>Categories:</ResultsHeader>
                    {scenesCategories.map(categorie => (
                        <ResultContainer key={categorie.id}>
                            <ResultLink
                                title={categorie.name}
                                onClick={handleSearchResultClick}
                                to={{
                                    type: 'EXPLORE_SCENES',
                                    query: {
                                        q: categorie.id,
                                        source,
                                    },
                                }}
                            >
                                {categorie.name}
                            </ResultLink>
                        </ResultContainer>
                    ))}
                </div>
            )}
        </SearchResults>
    );
};

SearchResult.propTypes = {
    handleOnchangeType: PropTypes.func,
    handleSearchResultClick: PropTypes.func,
    isMobile: PropTypes.bool,
    isShow: PropTypes.bool,
    isLoading: PropTypes.bool,
    searchTypes: PropTypes.array,
    selectedType: PropTypes.string,
    searchResult: PropTypes.object,
    styles: PropTypes.object,
    source: PropTypes.string,
};

export default SearchResult;
